import { getAuth } from "firebase/auth";
import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
} from "react-router-dom";
import Result from "antd/es/result";
import { Button, message } from "antd";
import { apiClient } from "~/services/apiClient";
import {
  FormattedBuildingData,
  FormattedUnitData,
  LeaseApplicationSubmission,
} from "~/types";
import * as APITypes from "~/API";
import { INTENTS, redirectToSignupWithReturnUrl } from "~/utils";

export interface LeaseApplicationLoaderResult {
  entityType: APITypes.EntityType;
  [APITypes.EntityType.Unit]?: FormattedUnitData;
  [APITypes.EntityType.Building]?: FormattedBuildingData;
}

export type LeaseApplicationPageLoaderType = LeaseApplicationLoaderResult;

export const LeaseApplicationPageLoader = async ({
  request,
  params,
}: LoaderFunctionArgs) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return redirectToSignupWithReturnUrl(request);

  const entityID = params.entityID ?? "";
  const entityType = params.entityType ?? "";
  if (!entityID || !entityType) return redirect("/unit");

  const result = await apiClient.loader<LeaseApplicationLoaderResult>(
    "lease-application",
    { id: entityID, entityType }
  );

  if (!result.success || !result.data) {
    console.error("Lease application loader failed:", result.error);
    return redirect("/unit");
  }

  return result.data;
};


export const LeaseApplicationPageAction = async ({
  request,
}: ActionFunctionArgs) => {
  const formData = await request.formData();
  const intent = formData.get("intent");
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Response(JSON.stringify({ error: "Not authenticated" }), {
      headers: { "Content-Type": "application/json" },
      status: 401,
    });
  }

  if (intent !== INTENTS._submit_lease_application) {
    message.error("Intent not allowed on this page."); // TODO [Translate]
    return {};
  }

  try {
    const payload = JSON.parse(
      formData.get("body") as string
    ) as LeaseApplicationSubmission;

    const result = await apiClient.sendIntent(
      INTENTS._submit_lease_application,
      { authUID: user.uid, ...payload }
    );

    if (result.success) {
      message.success("Application submitted"); // TODO [Translate]
      return redirect("/");
    }

    message.error("Something went wrong during application submission."); // TODO [Translate]
  } catch (error) {
    throw new Response(JSON.stringify({ error }), {
      headers: { "Content-Type": "application/json" },
      status: 500,
    });
  }
  return {};
};

export const LeaseApplicationPageErrorBoundary = () => {
  return (
    <Result status="500" title="500" subTitle="Sorry, something went wrong.">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href="/">
          Back Home
        </Button>
      </div>
    </Result>
  );
};
